import { createReducer, on } from '@ngrx/store';

import { initialState, State } from './feature-flag.state';
import * as featureFlagActions from './feature-flag.actions';

export const featureFlagReducer = createReducer<State>(
  initialState,
  on(
    featureFlagActions.loadFeatureFlagsSuccess,
    (state, { flags }): State => ({
      ...state,
      flags,
      loaded: true,
      error: null,
    }),
  ),
  on(
    featureFlagActions.loadFeatureFlagsFailure,
    (state, { error }): State => ({
      ...state,
      loaded: false,
      error,
    }),
  ),
  on(featureFlagActions.clearFeatureFlags, (): State => initialState),
);
